import React from 'react'
import footerLogo from '../../assets/img/footer-logo.png';

const FooterCta = () => {
  return (
    <div className="footer-cta-wrapper">
        <div className="container">
            <div className="footer-cta-bg-wrapper">
                <div className="row justify-content-around align-items-center">
                    <div className="col-lg-3 col-md-3 col-12">
                        <div className="footer-logo">
                            <a >
                                <img src='/img/dhtech-icon-footer.svg' alt="logo"/>
                            </a>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-5 ps-lg-0 offset-lg-1 col-12">
                        <div className="footer-middle-text mt-4 mb-4 mt-md-0 mb-md-0 text-white">
                            <p>Our strength is our well experienced team with proven expertise in the respective fields.</p>
                        </div>
                    </div>
                    <div className="col-md-4 col-lg-4 col-12">
                        <div className="footer-social-icon ms-md-5 text-lg-md-end">
                             <a href="https://www.facebook.com/profile.php?id=61575105304065" target="_blank" rel="noopener noreferrer">
    <i className="fab fa-facebook-f"></i>
  </a>

  <a href="https://wa.me/9710502033924" target="_blank" rel="noopener noreferrer">
    <i className="fab fa-whatsapp"></i>
  </a>

  <a href="https://www.instagram.com/diamond_houseuae/" target="_blank" rel="noopener noreferrer">
    <i className="fab fa-instagram"></i>
  </a>

  <a href="https://www.linkedin.com/company/diamond-house-technical-services/posts/?feedView=all" target="_blank" rel="noopener noreferrer">
    <i className="fab fa-linkedin-in"></i>
  </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

  )
}

export default FooterCta